import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { AlertCircle, Eye, EyeOff } from "lucide-react";

interface FormFieldProps {
  id: string;
  name: string;
  label: string;
  type?: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  showPasswordToggle?: boolean;
  showPassword?: boolean;
  onTogglePassword?: () => void;
}

const FormField = ({
  id,
  name,
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  error,
  showPasswordToggle = false,
  showPassword,
  onTogglePassword,
}: FormFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor={id} className="text-white">
        {label}
      </Label>
      <div className="relative">
        <Input
          id={id}
          name={name}
          type={showPasswordToggle && showPassword ? "text" : type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className={`bg-black/50 border-white/20 text-white ${
            error ? "border-red-500" : ""
          } ${showPasswordToggle ? "pr-10" : ""}`}
        />
        {showPasswordToggle && (
          <div
            className="absolute right-0 top-0 h-10 w-10 flex items-center justify-center cursor-pointer group"
            onClick={onTogglePassword}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? (
              <EyeOff className="h-4 w-4 text-gray-500 group-hover:text-[#ff6c24] transition-colors" />
            ) : (
              <Eye className="h-4 w-4 text-gray-500 group-hover:text-[#ff6c24] transition-colors" />
            )}
          </div>
        )}
      </div>
      {error && (
        <p className="text-red-500 text-sm flex items-center gap-1 mt-1">
          <AlertCircle size={14} /> {error}
        </p>
      )}
    </div>
  );
};

export default FormField;
